import { useEffect, useState } from 'react';
import jobTitlesApi from '../../../Api/axios/job-titles-api';
import useTranslation from '../../../Hooks/useTranslation';

const useJobTitle = setIsLoading => {
  const { t } = useTranslation();
  const [jobTitles, setJobTitles] = useState([]);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    jobTitlesApi
      .readAll()
      .then(response => {
        if (isMounted && response.data) {
          const jobTitlesList = response.data.map(jobTitle => [
            jobTitle.name,
            jobTitle.totalUsers,
            jobTitle.Department.name,
            jobTitle.status ? t('Generic.Active') : t('Generic.Inactive'),
            jobTitle.id,
          ]);
          setJobTitles(jobTitlesList);
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsLoading]);

  return {
    jobTitles,
    setJobTitles,
  };
};

export default useJobTitle;
